import {GeometryBuffer, vec3, Mesh, mat4} from '../beam/index';

import Container from '../beam/Container';
import buildMesh from './loaders/buildMesh'
import MeshSurfaceSampler from './MeshSurfaceSampler';

export default class ParticleSystem extends Mesh {
	
	constructor(gl, options) {
        
        super(options)

	    if (!gl) {
            return;
        }
          
        this.gl = gl;
    
		options = Object.assign({}, {
            size: 4000
		}, options);

        this.numParticles =  this.options.size;

        this.options      = options;
        this.geometry     = new GeometryBuffer(gl)
        let particleMaterial = buildMesh(this.gl, { 
            albedoMap:  this.options.albedoMap,
            alphaMap:   this.options.alphaMap,
            normalMap:  this.options.normalMap,
            color:      [0, 1, 0],
            instancing: true
        });
        this.material = particleMaterial.material
        this.uniforms = particleMaterial._uniforms;

        if (this.options.positions) {
            this.surfaceSampler = new MeshSurfaceSampler(this.options.positions)
        }

        this.keep = true//dont frustum cull
        
        let vertices = []
        let normals  = []
        let colors   = [];
        let uvs      = [];
        let indices  = []
        if (this.options.geometry) {
            // if (this.options.geometry.attributes.index) {
            //     let _positions       = this.options.geometry.attributes.position.data
            //     let _normals         = this.options.geometry.attributes.normal.data
            //     let _uvs             = this.options.geometry.attributes.uv.data
            //     let _colors          = this.options.geometry.attributes.color.data
            //     let indexedPositions = []
            //     let indexedNormals   = []
            //     let indexedUvs       = []
            //     let indexedColors    = []
            //     let indices = this.options.geometry.attributes.index.data
            //     for (let i=0; i<indices.length; i++) {
            //         let vertexIndex = indices[ i ];
            //         indexedPositions.push( _positions[vertexIndex*3+0], _positions[vertexIndex*3+1], _positions[vertexIndex*3+2] )
            //         indexedNormals.push( _normals[vertexIndex*3+0], _normals[vertexIndex*3+1], _normals[vertexIndex*3+2] )
            //         indexedUvs.push( _uvs[vertexIndex*2+0], _uvs[vertexIndex*2+1] )
            //         indexedColors.push( _colors[vertexIndex*3+0], _colors[vertexIndex*3+1], _colors[vertexIndex*3+2] )
            //     }
            //     Array.prototype.push.apply( vertices, indexedPositions )
            //     Array.prototype.push.apply( normals, indexedNormals )
            //     Array.prototype.push.apply( uvs, indexedUvs )
            //     Array.prototype.push.apply( colors, indexedColors )
            // }
            // else {
            //     Array.prototype.push.apply( vertices, this.options.geometry.attributes.position.data )
            //     Array.prototype.push.apply( normals, this.options.geometry.attributes.normal.data )
            //     Array.prototype.push.apply( uvs, this.options.geometry.attributes.uv.data )
            //     Array.prototype.push.apply( colors, this.options.geometry.attributes.color.data )
            // }

            // vertices = Array.from(this.options.geometry.attributes.position.data)
            // normals = Array.from(this.options.geometry.attributes.normal.data)
            // uvs = Array.from(this.options.geometry.attributes.uv.data)
            // colors = Array.from(this.options.geometry.attributes.color.data)
            // indices = Array.from(this.options.geometry.attributes.index.data)
            this.geometry = this.options.geometry
        }

        // this.geometry.length = vertices.length/3;
        // this.geometry.addAttribute( 'position', new Float32Array( vertices ), 3 );
        // this.geometry.addAttribute( 'color',    new Float32Array( colors ), 3 );
        // this.geometry.addAttribute( 'uv',       new Float32Array( uvs ), 2 );
        // this.geometry.addAttribute( 'normal',   new Float32Array( normals ), 3 );
        // this.geometry.addAttribute( 'index',   new Uint16Array( indices ), 1 );


        let dummy = new Container();
        let instanceMatrices = new Array( this.numParticles * 16 );
        for (let i=0; i<this.numParticles; i++) {

            if (this.options.isSmall) {
                vec3.set(
                    dummy.position, 
                    (((Math.random())-.5)*2) * (2500 ), 
                    (((Math.random())-.5)*2) * (20), 
                    (((Math.random())-.5)*2) * (2500) 
                )
            }
            else {
                let randPos = this.surfaceSampler.sample()
                randPos[1] -= 50;
                vec3.copy(dummy.position, randPos);
                // vec3.set(dummy.position, Math.random() * (50000*2) - 50000, Math.random() * 200, Math.random()*-50000 )
            }

            vec3.set(dummy.rotation, (Math.random()-0.5)*2*0.1, Math.random() * Math.PI*2, (Math.random()-0.5)*2*0.1 )
            vec3.set(dummy.scale, 3, 3,3 )
            dummy.updateMatrix();
            instanceMatrices[i*16+0]  = dummy.matrix[0]
            instanceMatrices[i*16+1]  = dummy.matrix[1]
            instanceMatrices[i*16+2]  = dummy.matrix[2]
            instanceMatrices[i*16+3]  = dummy.matrix[3]
            instanceMatrices[i*16+4]  = dummy.matrix[4]
            instanceMatrices[i*16+5]  = dummy.matrix[5]
            instanceMatrices[i*16+6]  = dummy.matrix[6]
            instanceMatrices[i*16+7]  = dummy.matrix[7]
            instanceMatrices[i*16+8]  = dummy.matrix[8]
            instanceMatrices[i*16+9]  = dummy.matrix[9]
            instanceMatrices[i*16+10] = dummy.matrix[10]
            instanceMatrices[i*16+11] = dummy.matrix[11]
            instanceMatrices[i*16+12] = dummy.matrix[12]
            instanceMatrices[i*16+13] = dummy.matrix[13]
            instanceMatrices[i*16+14] = dummy.matrix[14]
            instanceMatrices[i*16+15] = dummy.matrix[15]
        }

        this.geometry.addAttribute( 'instanceMatrix', new Float32Array(instanceMatrices), 16 );

    }

}